module.exports = __webpack_public_path__ + "static/img/shop-style-1.33be4f26.png";